import { pList, rEmlakVergiUstbilgiDetay, rList } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';
import { rEmlakVergiUstbilgiDetay_RawData } from '../../../../api/models/rEmlakVergiUstbilgiDetay';

export const action_async_start_promise = (body: pList): IPromiseAction<pList> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_OYAKEMLAKVERGILERIDETAYTOPLAMDEGER,
    new Api.Stat.OyakEmlakVergileriDetayToplamDeger().Request(body),
    false,
    true,
    body
  );

export const action_async_complete_api = (
  data: rList<rEmlakVergiUstbilgiDetay_RawData> | null | undefined,
  error: IError | null | undefined
): IApiAction<rEmlakVergiUstbilgiDetay> =>
  ActionFunctions.action_async_complete_api<rEmlakVergiUstbilgiDetay>(
    ActionSubTypes.API_OYAKEMLAKVERGILERIDETAYTOPLAMDEGER,
    new rEmlakVergiUstbilgiDetay({ Data: data?.Values }),
    error
  );
